var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "AddForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Name", "label-for": "Name" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Name",
                                vid: "Name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "Milestone_title",
                                            placeholder: "Title",
                                          },
                                          model: {
                                            value: _vm.milestone.name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.milestone,
                                                "name",
                                                $$v
                                              )
                                            },
                                            expression: "milestone.name",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Description",
                              "label-for": "Milestone_description",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Description",
                                vid: "Description",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            id: "Milestone_description",
                                            placeholder: "Description",
                                            rows: "3",
                                          },
                                          model: {
                                            value: _vm.milestone.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.milestone,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "milestone.description",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Start Date",
                              "label-for": "start_date",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Start Date",
                                vid: "start_date",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "start_date",
                                            placeholder: "Choose a date",
                                          },
                                          model: {
                                            value: _vm.milestone.startDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.milestone,
                                                "startDate",
                                                $$v
                                              )
                                            },
                                            expression: "milestone.startDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "End Date",
                              "label-for": "end_date",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "End Date",
                                vid: "end_date",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "end_date",
                                            min:
                                              _vm.milestone.startDate ||
                                              _vm.currentDate,
                                            placeholder: "Choose a date",
                                            local: "en",
                                            "initial-date": "2024-06-16",
                                          },
                                          model: {
                                            value: _vm.milestone.endDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.milestone,
                                                "endDate",
                                                $$v
                                              )
                                            },
                                            expression: "milestone.endDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-between",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "button", variant: "primary" },
                            on: { click: _vm.formSubmitted },
                          },
                          [_vm._v("Submit")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }